import script from "./YouArrived.vue?vue&type=script&setup=true&lang=js"
export * from "./YouArrived.vue?vue&type=script&setup=true&lang=js"

import "./YouArrived.vue?vue&type=style&index=0&id=3c87b512&lang=css"

const __exports__ = script;

export default __exports__